// extracted by mini-css-extract-plugin
module.exports = {"contactLinks":"styles-module--contactLinks--eYQ3c","title":"styles-module--title--2tW5Z"};